<template>
  <div class="fixed inset-0 z-40 overflow-y-auto">
    <transition name="fade" appear>
      <div
        class="bg-ontick-carbon-900 fixed inset-0 bg-opacity-75 backdrop-blur-sm backdrop-filter"
      ></div>
    </transition>
    <button
      class="fixed inset-0 cursor-default"
      @click.self="$emit('close')"
    ></button>

    <div
      class="pointer-events-none fixed inset-0 flex items-center justify-center"
    >
      <transition name="fade" appear>
        <div
          class="bg-ontick-carbon-500 divide-ontick-steel-500 pointer-events-auto relative w-[566px] divide-y-2 rounded-[32px] p-6"
        >
          <div class="flex flex-col gap-6 pb-4">
            <div class="flex flex-col items-center justify-center gap-4">
              <i>
                <svg
                  width="106"
                  height="100"
                  viewBox="0 0 106 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.3699 86.6992H85.6299C92.3032 86.6992 96.4632 79.4625 93.1265 73.6992L60.4965 17.3225C57.1599 11.5592 48.8399 11.5592 45.5032 17.3225L12.8732 73.6992C9.53654 79.4625 13.6965 86.6992 20.3699 86.6992ZM52.9999 56.3658C50.6165 56.3658 48.6665 54.4158 48.6665 52.0325V43.3658C48.6665 40.9825 50.6165 39.0325 52.9999 39.0325C55.3832 39.0325 57.3332 40.9825 57.3332 43.3658V52.0325C57.3332 54.4158 55.3832 56.3658 52.9999 56.3658ZM57.3332 73.6992H48.6665V65.0325H57.3332V73.6992Z"
                    fill="#D7C94E"
                  />
                </svg>
              </i>
              <p class="text-3xl font-bold">
                Parar <span class="uppercase">best?</span>
              </p>
            </div>
            <!-- <p class="text-ontick-yellow-700">
              Atenção! Ao encerrar este Best antecipadamente não serão
              computados OnTick Points para o leaderboard. Deseja continuar com
              esta ação?
            </p> -->
          </div>
          <div class="pt-6">
            <button
              :disabled="button_is_disabled"
              class="bg-ontick-blue-900 flex w-full items-center justify-center overflow-hidden rounded-lg p-2 font-semibold text-gray-50 transition-all hover:brightness-125 disabled:cursor-not-allowed disabled:contrast-0"
              @click="stop"
            >
              <i v-html="$icons.loading" v-if="on_timeout"> </i>
              <span v-else> Encerrar antecipadamente </span>
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import api from "../../../core/http/axios";
import routes from "../../../core/config/api-ontick.routes";
import { mapGetters } from "vuex";
import event_bus from "../../../shared/utils/event_bus";
export default {
  props: {
    data: {
      type: Object,
    },
  },

  data() {
    return {
      button_is_disabled: false,
      on_timeout: false,
    };
  },

  computed: {
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getUserBests: "bests/getUserBests",
    }),
  },

  methods: {
    async time(ms) {
      return new Promise((res) => {
        setTimeout(res, ms);
      });
    },
    async stop() {
      this.button_is_disabled = true;
      try {
        const account_id = this.getSelectedAccount.account_id;
        const bo_id = this.data.bo_id;
        const { data } = await api.post(routes.STOP_BEST, {
          account_id,
          bo_id,
        });
        await this.$swal("Best parada", data.msg, "success");
        event_bus.$emit("BEST_STOPPED");
        this.$emit("stop");
      } catch (err) {
        this.$swal("Erro", err.data.msg, "error");
      } finally {
        this.button_is_disabled = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
dl {
  @apply flex w-full items-center justify-between;
  dd {
    @apply text-right font-semibold;
  }
}
.best-shadow {
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 1);
}

.fade {
  &-enter,
  &-leave-to {
    @apply scale-125 opacity-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-300 ease-in-out;
  }
}
</style>
